export default "__VITE_ASSET__197987cc__"